import React from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import * as PersonActions from '../Actions/PersonActivityAction';
import OptinSuccess from '../Components/OptinSuccess/OptinSuccess';

class OptinContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showErrorPage: false,
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const { ref } = queryString.parse(location.search);
    if (!ref) {
      this.setState({
        showErrorPage: true,
      });
    }
    PersonActions.updateConsentStatus(ref, 'Approved');
  }

  render() {
    const { showErrorPage } = this.state;
    if (showErrorPage) {
      return <div>Invalid URL</div>;
    }
    return <OptinSuccess />;
  }
}

export default withRouter(OptinContainer);
